import { Moon, Sun } from 'lucide-react';

import { Button } from '../components/Button';
import { useTheme } from './theme';

export function ThemeToggle() {
    const { theme, toggleTheme } = useTheme();
    const Icon = theme === 'dark' ? Sun : Moon;
    const label = theme === 'dark' ? 'Schimba la modul luminos' : 'Schimba la modul intunecat';

    return (
        <Button variant="ghost" size="sm" onClick={toggleTheme} aria-label={label} title={label}>
            <Icon aria-hidden="true" className="h-5 w-5" />
        </Button>
    );
}
